module.exports = __webpack_public_path__ + "img/b7301acc80fd9f361d9fce9f3f25a828.png";